function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 171.4003,
    cy: 135.2401,
    r: 733.4801,
    gradientTransform: "matrix(1.0858 0 0 1.088 -119.9181 -249.2813)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4C02F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0082,
    style: {
      stopColor: "#4B02EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    style: {
      stopColor: "#3903C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2487,
    style: {
      stopColor: "#29039E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#1D0380"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    style: {
      stopColor: "#130468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6513,
    style: {
      stopColor: "#0C0457"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8062,
    style: {
      stopColor: "#07044D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#06044A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 600,
    height: 450
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.327,397.747v-9.715h2.361c0.613,0,1.124,0.057,1.532,0.17c0.408,0.113,0.734,0.299,0.978,0.557 c0.244,0.258,0.417,0.572,0.519,0.941c0.102,0.369,0.152,0.83,0.152,1.385v3.504c0,0.563-0.051,1.035-0.152,1.418 c-0.102,0.383-0.273,0.709-0.516,0.977c-0.242,0.268-0.564,0.461-0.967,0.582c-0.402,0.121-0.902,0.182-1.5,0.182H256.327z  M258.302,396.37h0.41c0.137,0,0.259-0.008,0.366-0.023c0.107-0.016,0.2-0.043,0.278-0.082c0.078-0.039,0.145-0.078,0.199-0.119 c0.055-0.041,0.1-0.102,0.138-0.18c0.037-0.078,0.066-0.15,0.088-0.219c0.022-0.068,0.037-0.164,0.047-0.285 c0.01-0.121,0.016-0.229,0.018-0.322c0.002-0.094,0.003-0.221,0.003-0.381v-3.897c0-0.23-0.006-0.414-0.018-0.551 c-0.012-0.137-0.039-0.268-0.082-0.395c-0.043-0.127-0.106-0.223-0.19-0.285c-0.084-0.063-0.196-0.111-0.337-0.148 c-0.141-0.037-0.316-0.057-0.527-0.057h-0.393V396.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.556,397.747l1.898-9.715h2.168l1.892,9.715h-1.834l-0.358-2.15h-1.541l-0.357,2.15H262.556z  M264.97,394.372h1.154l-0.58-3.867L264.97,394.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M270.109,397.747v-8.256h-1.553v-1.459h5.057v1.459h-1.529v8.256H270.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.882,397.747l1.898-9.715h2.168l1.893,9.715h-1.834l-0.357-2.15h-1.541l-0.357,2.15H273.882z  M276.296,394.372h1.154l-0.58-3.867L276.296,394.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.82,397.747v-9.715h3.035c1.688,0,2.531,0.93,2.531,2.789c0,0.504-0.066,0.935-0.199,1.293 c-0.133,0.357-0.324,0.637-0.574,0.838c-0.25,0.201-0.533,0.346-0.85,0.434s-0.68,0.131-1.09,0.131h-0.879v4.23H283.82z  M285.794,392.134h0.633c0.438,0,0.73-0.098,0.879-0.295c0.148-0.197,0.223-0.545,0.223-1.041c0-0.254-0.011-0.453-0.032-0.6 c-0.021-0.146-0.068-0.285-0.141-0.416c-0.072-0.131-0.184-0.225-0.334-0.279c-0.15-0.055-0.349-0.082-0.595-0.082h-0.633V392.134z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M290.365,397.747v-9.715h2.455c0.516,0,0.959,0.041,1.33,0.121c0.371,0.08,0.7,0.215,0.987,0.406 c0.287,0.191,0.502,0.457,0.645,0.797c0.143,0.34,0.214,0.758,0.214,1.254c0,0.625-0.089,1.131-0.267,1.518 c-0.178,0.387-0.483,0.68-0.917,0.879l1.342,4.74h-2.016l-1.113-4.383h-0.685v4.383H290.365z M292.339,392.169h0.492 c0.477,0,0.815-0.111,1.014-0.336s0.299-0.584,0.299-1.076c0-0.48-0.087-0.83-0.261-1.051s-0.487-0.332-0.94-0.332h-0.603V392.169z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.027,397.876c-0.527,0-0.977-0.07-1.348-0.213c-0.371-0.143-0.667-0.355-0.888-0.639 s-0.381-0.617-0.48-1c-0.1-0.383-0.149-0.834-0.149-1.354v-3.586c0-0.52,0.05-0.969,0.149-1.35c0.1-0.381,0.26-0.711,0.48-0.988 c0.221-0.277,0.517-0.486,0.888-0.627c0.371-0.141,0.82-0.211,1.348-0.211c1.027,0,1.765,0.268,2.212,0.803 c0.447,0.535,0.671,1.326,0.671,2.373v3.586c0,1.047-0.224,1.844-0.671,2.389C301.791,397.604,301.054,397.876,300.027,397.876z  M299.646,396.38c0.105,0.049,0.232,0.072,0.381,0.072c0.148,0,0.276-0.023,0.384-0.072c0.108-0.049,0.191-0.111,0.252-0.186 c0.06-0.074,0.108-0.172,0.144-0.293c0.035-0.121,0.058-0.236,0.067-0.348c0.01-0.111,0.015-0.246,0.015-0.402v-4.547 c0-0.156-0.005-0.289-0.015-0.4c-0.01-0.111-0.032-0.227-0.067-0.344c-0.035-0.117-0.083-0.211-0.144-0.283 c-0.061-0.072-0.145-0.133-0.252-0.18c-0.107-0.047-0.235-0.07-0.384-0.07c-0.148,0-0.275,0.023-0.381,0.07 c-0.105,0.047-0.188,0.108-0.246,0.18c-0.059,0.072-0.104,0.168-0.138,0.287c-0.033,0.119-0.055,0.232-0.064,0.342 c-0.01,0.109-0.015,0.242-0.015,0.398v4.547c0,0.156,0.005,0.291,0.015,0.402c0.01,0.111,0.031,0.227,0.064,0.348 c0.033,0.121,0.079,0.219,0.138,0.293C299.458,396.268,299.54,396.331,299.646,396.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M306.906,397.876c-0.532,0-0.985-0.076-1.36-0.23s-0.67-0.381-0.885-0.678 c-0.215-0.297-0.369-0.637-0.463-1.02c-0.094-0.383-0.141-0.828-0.141-1.336v-3.428c0-0.527,0.047-0.984,0.141-1.371 c0.094-0.387,0.248-0.727,0.463-1.02c0.215-0.293,0.509-0.514,0.882-0.662c0.373-0.148,0.827-0.223,1.363-0.223 c0.508,0,0.94,0.066,1.298,0.197c0.357,0.131,0.639,0.322,0.844,0.576c0.205,0.254,0.354,0.547,0.445,0.877 c0.092,0.33,0.138,0.715,0.138,1.156v0.844h-1.928v-0.914c0-0.109,0-0.186,0-0.228c0-0.043-0.002-0.113-0.006-0.211 c-0.004-0.098-0.011-0.166-0.021-0.207c-0.01-0.041-0.023-0.102-0.041-0.18c-0.017-0.078-0.039-0.135-0.064-0.17 c-0.025-0.035-0.058-0.078-0.097-0.129c-0.039-0.051-0.085-0.086-0.138-0.107c-0.053-0.022-0.115-0.041-0.188-0.059 c-0.072-0.018-0.151-0.027-0.237-0.027c-0.152,0-0.282,0.027-0.39,0.08c-0.108,0.053-0.191,0.117-0.25,0.195 c-0.059,0.078-0.104,0.186-0.135,0.32c-0.031,0.135-0.051,0.26-0.059,0.375c-0.008,0.115-0.012,0.26-0.012,0.436v4.342 c0,0.473,0.06,0.82,0.179,1.043c0.119,0.223,0.341,0.334,0.665,0.334c0.125,0,0.234-0.016,0.328-0.047 c0.094-0.031,0.169-0.082,0.226-0.154c0.057-0.072,0.102-0.143,0.135-0.211c0.033-0.068,0.057-0.166,0.07-0.291 c0.014-0.125,0.023-0.23,0.026-0.316c0.004-0.086,0.006-0.205,0.006-0.357v-0.949h1.928v0.82c0,0.449-0.044,0.844-0.132,1.182 c-0.088,0.338-0.231,0.643-0.431,0.914c-0.199,0.271-0.48,0.478-0.844,0.621C307.861,397.805,307.422,397.876,306.906,397.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M310.82,397.747v-9.715h4.23v1.371h-2.256v2.572h1.752v1.383h-1.752v3.041h2.279v1.348H310.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.59,397.876c-0.902,0-1.576-0.248-2.021-0.744c-0.445-0.496-0.688-1.258-0.727-2.285 l1.711-0.305c0.008,0.605,0.089,1.063,0.243,1.369c0.154,0.307,0.392,0.459,0.712,0.459c0.23,0,0.397-0.074,0.501-0.223 c0.103-0.148,0.155-0.34,0.155-0.574c0-0.383-0.083-0.703-0.249-0.963c-0.166-0.26-0.433-0.551-0.8-0.871l-1.043-0.902 c-0.266-0.23-0.48-0.445-0.642-0.647c-0.162-0.201-0.299-0.457-0.41-0.768c-0.111-0.311-0.167-0.656-0.167-1.035 c0-0.785,0.232-1.393,0.697-1.824c0.465-0.432,1.104-0.65,1.916-0.654c0.273,0,0.523,0.027,0.75,0.082 c0.227,0.055,0.421,0.129,0.583,0.223c0.162,0.094,0.306,0.211,0.431,0.352c0.125,0.141,0.227,0.287,0.305,0.438 c0.078,0.15,0.145,0.32,0.199,0.51c0.055,0.189,0.094,0.369,0.117,0.539c0.023,0.17,0.041,0.354,0.053,0.553l-1.699,0.27 c-0.008-0.199-0.018-0.365-0.029-0.498c-0.012-0.133-0.034-0.27-0.067-0.412c-0.033-0.142-0.077-0.254-0.132-0.334 c-0.055-0.08-0.129-0.147-0.223-0.197c-0.094-0.051-0.205-0.072-0.334-0.065c-0.219,0.012-0.388,0.096-0.507,0.252 c-0.119,0.156-0.179,0.346-0.179,0.568c0,0.176,0.021,0.336,0.061,0.479c0.041,0.143,0.108,0.277,0.202,0.406 c0.094,0.129,0.179,0.232,0.255,0.311c0.076,0.078,0.187,0.184,0.331,0.316l1.025,0.891c0.219,0.195,0.409,0.385,0.571,0.568 c0.162,0.184,0.315,0.393,0.46,0.627c0.145,0.234,0.255,0.492,0.331,0.773c0.076,0.281,0.114,0.58,0.114,0.896 c0,0.707-0.229,1.287-0.688,1.74C319.938,397.649,319.336,397.876,318.59,397.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.642,397.876c-0.902,0-1.576-0.248-2.021-0.744c-0.445-0.496-0.688-1.258-0.727-2.285 l1.711-0.305c0.008,0.605,0.089,1.063,0.243,1.369c0.154,0.307,0.392,0.459,0.712,0.459c0.23,0,0.397-0.074,0.501-0.223 c0.103-0.148,0.155-0.34,0.155-0.574c0-0.383-0.083-0.703-0.249-0.963c-0.166-0.26-0.433-0.551-0.8-0.871l-1.043-0.902 c-0.266-0.23-0.479-0.445-0.642-0.647c-0.162-0.201-0.299-0.457-0.41-0.768c-0.111-0.311-0.167-0.656-0.167-1.035 c0-0.785,0.232-1.393,0.697-1.824c0.465-0.432,1.103-0.65,1.916-0.654c0.273,0,0.523,0.027,0.75,0.082 c0.227,0.055,0.421,0.129,0.583,0.223c0.162,0.094,0.306,0.211,0.431,0.352c0.125,0.141,0.227,0.287,0.305,0.438 c0.078,0.15,0.145,0.32,0.199,0.51c0.055,0.189,0.094,0.369,0.117,0.539c0.023,0.17,0.041,0.354,0.053,0.553l-1.699,0.27 c-0.008-0.199-0.018-0.365-0.029-0.498c-0.012-0.133-0.034-0.27-0.067-0.412c-0.033-0.142-0.077-0.254-0.132-0.334 c-0.055-0.08-0.129-0.147-0.223-0.197c-0.094-0.051-0.205-0.072-0.334-0.065c-0.219,0.012-0.388,0.096-0.507,0.252 c-0.119,0.156-0.179,0.346-0.179,0.568c0,0.176,0.021,0.336,0.061,0.479c0.041,0.143,0.108,0.277,0.202,0.406 c0.094,0.129,0.179,0.232,0.255,0.311c0.076,0.078,0.186,0.184,0.331,0.316l1.025,0.891c0.219,0.195,0.409,0.385,0.571,0.568 c0.162,0.184,0.315,0.393,0.46,0.627c0.145,0.234,0.255,0.492,0.331,0.773c0.076,0.281,0.114,0.58,0.114,0.896 c0,0.707-0.229,1.287-0.688,1.74C325.991,397.649,325.388,397.876,324.642,397.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.211,397.747v-9.715h1.963v9.715H328.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.638,397.747v-9.715h1.377l2.168,5.045v-5.045h1.641v9.715h-1.318l-2.18-5.367v5.367H331.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.756,397.882c-0.48,0-0.893-0.078-1.236-0.234c-0.344-0.156-0.617-0.385-0.82-0.685 s-0.351-0.65-0.442-1.051c-0.092-0.4-0.138-0.867-0.138-1.398v-3.199c0-0.438,0.028-0.826,0.085-1.166 c0.057-0.34,0.153-0.652,0.29-0.939c0.137-0.287,0.313-0.523,0.527-0.709c0.215-0.186,0.485-0.33,0.811-0.434 c0.326-0.103,0.704-0.156,1.134-0.156c0.508,0,0.943,0.064,1.307,0.191c0.363,0.127,0.651,0.316,0.864,0.57 c0.213,0.254,0.367,0.551,0.463,0.891c0.096,0.34,0.143,0.738,0.143,1.195v0.551h-1.916v-0.656c0-0.18-0.004-0.326-0.012-0.439 c-0.008-0.113-0.027-0.23-0.059-0.354c-0.031-0.123-0.076-0.221-0.135-0.291c-0.059-0.07-0.14-0.127-0.243-0.172 s-0.232-0.068-0.384-0.068c-0.16,0-0.295,0.029-0.404,0.086c-0.109,0.057-0.193,0.125-0.252,0.205 c-0.059,0.08-0.104,0.191-0.138,0.336c-0.033,0.145-0.053,0.273-0.059,0.387c-0.006,0.113-0.009,0.262-0.009,0.445v4.213 c0,0.473,0.064,0.832,0.193,1.078c0.129,0.246,0.369,0.369,0.721,0.369c0.355,0,0.603-0.131,0.741-0.395 c0.139-0.264,0.208-0.641,0.208-1.129v-0.955h-0.955v-1.219h2.736v4.998h-1.295l-0.129-0.891 C342.062,397.54,341.529,397.882,340.756,397.882z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086661722674033361850000011204460593357132679_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.6209,
    y1: 248.3125,
    x2: 506.2322,
    y2: 248.3125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086661722674033361850000011204460593357132679_)"
    },
    d: "M489.927,257.901 c-1.203,0-2.407-0.309-3.48-0.93l0,0l-11.737-6.776c-0.681-0.393-1.088-1.097-1.088-1.883c0-0.785,0.407-1.489,1.088-1.882 l11.736-6.776c2.147-1.24,4.815-1.24,6.962,0l11.737,6.776c0.681,0.393,1.088,1.097,1.088,1.882c0,0.786-0.407,1.49-1.088,1.883 l-11.736,6.776C492.335,257.592,491.131,257.901,489.927,257.901z M487.376,255.36c1.575,0.909,3.529,0.908,5.103,0l11.736-6.776 c0.136-0.079,0.156-0.204,0.156-0.271c0-0.066-0.021-0.191-0.156-0.271l-11.737-6.776c-1.574-0.908-3.528-0.908-5.103,0 l-11.736,6.776c-0.136,0.079-0.156,0.204-0.156,0.271c0,0.067,0.02,0.192,0.156,0.271L487.376,255.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127037271738453637370000016192507148848416642_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.3597,
    y1: 312.4481,
    x2: 331.1375,
    y2: 312.4481
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127037271738453637370000016192507148848416642_)"
    },
    d: "M303.749,328.279 c-1.956,0-3.911-0.503-5.656-1.511l-20.199-11.661c-0.961-0.556-1.535-1.55-1.535-2.66c0-1.109,0.574-2.102,1.535-2.657 l20.198-11.661c3.489-2.016,7.823-2.016,11.312,0l20.198,11.662c0.961,0.555,1.535,1.549,1.535,2.658s-0.574,2.103-1.535,2.658 l-20.198,11.661C307.661,327.775,305.705,328.279,303.749,328.279z M303.748,298.478c-1.634,0-3.268,0.421-4.725,1.262 l-20.198,11.661c-0.545,0.316-0.604,0.837-0.604,1.047c0,0.21,0.059,0.732,0.605,1.048l20.198,11.661l0,0 c2.915,1.682,6.535,1.682,9.449,0l20.199-11.661c0.545-0.316,0.604-0.837,0.604-1.047s-0.059-0.731-0.604-1.047l-20.198-11.662 C307.016,298.899,305.383,298.478,303.748,298.478z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141456519885502518620000000610574837359130779_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.2904,
    y1: 312.4487,
    x2: 330.2072,
    y2: 312.4487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000141456519885502518620000000610574837359130779_)"
    },
    d: "M298.559,325.963 l-20.199-11.662c-1.426-0.823-1.426-2.882,0-3.705l20.198-11.661c3.212-1.854,7.169-1.854,10.381,0l20.199,11.662 c1.426,0.824,1.426,2.882,0,3.705l-20.198,11.661C305.728,327.817,301.771,327.817,298.559,325.963z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123409653638637171930000003268362079378491545_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.7269,
    y1: 239.8049,
    x2: 161.094,
    y2: 239.8049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123409653638637171930000003268362079378491545_)"
    },
    d: "M113.911,266.887 c-3.323,0-6.646-0.855-9.61-2.567l-35.13-20.282c-1.53-0.884-2.443-2.466-2.443-4.232s0.913-3.349,2.443-4.232l35.129-20.281 c5.928-3.423,13.293-3.424,19.221,0l35.131,20.282c1.53,0.884,2.444,2.466,2.443,4.233c0,1.766-0.913,3.348-2.443,4.23 l-35.129,20.282C120.557,266.031,117.234,266.887,113.911,266.887z M113.91,215.055c-2.92,0-5.84,0.752-8.444,2.256l-35.129,20.281 c-0.8,0.462-1.277,1.289-1.277,2.213c0,0.924,0.478,1.751,1.277,2.213l35.13,20.282l0,0c5.209,3.008,11.68,3.008,16.889,0 l35.129-20.282c0.8-0.462,1.277-1.288,1.277-2.212c0-0.924-0.477-1.751-1.277-2.213l-35.131-20.282 C119.749,215.806,116.829,215.055,113.91,215.055z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048476584303760900850000011202199695159665801_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.4383,
    y1: 160.4765,
    x2: 216.2137,
    y2: 160.4765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048476584303760900850000011202199695159665801_)"
    },
    d: "M177.827,182.502 c-2.702,0-5.404-0.695-7.814-2.087l0,0l-28.595-16.51c-1.24-0.716-1.98-1.997-1.98-3.429c0-1.432,0.74-2.713,1.98-3.429 l28.594-16.509c4.819-2.783,10.807-2.783,15.627,0l28.596,16.51c1.24,0.716,1.98,1.998,1.979,3.43c0,1.431-0.74,2.712-1.979,3.427 l-28.594,16.51C183.23,181.806,180.528,182.502,177.827,182.502z M170.944,178.803c4.246,2.45,9.52,2.451,13.766,0l28.594-16.51 c0.657-0.379,1.049-1.058,1.049-1.816c0.001-0.759-0.392-1.438-1.049-1.817l-28.596-16.51c-4.246-2.449-9.52-2.451-13.765,0 l-28.594,16.509c-0.657,0.38-1.049,1.059-1.049,1.817c0,0.759,0.392,1.438,1.049,1.817L170.944,178.803z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082338417477851102610000013039904971275609782_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.3687,
    y1: 160.4767,
    x2: 215.2829,
    y2: 160.4767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000082338417477851102610000013039904971275609782_)"
    },
    d: "M170.478,179.609 l-28.595-16.51c-2.019-1.166-2.019-4.08,0-5.246l28.594-16.509c4.547-2.625,10.149-2.625,14.696,0l28.595,16.51 c2.019,1.166,2.019,4.08,0,5.246l-28.594,16.509C180.627,182.234,175.025,182.234,170.478,179.609z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032618913285332236980000016387545733835967119_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.6316,
    y1: 192.665,
    x2: 510.9715,
    y2: 192.665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E95F8D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032618913285332236980000016387545733835967119_)"
    },
    d: "M457.302,223.297 c-3.738,0-7.477-0.962-10.81-2.888l0,0l-40.262-23.245c-1.628-0.939-2.599-2.621-2.599-4.5c0-1.878,0.972-3.559,2.599-4.497 l40.26-23.245c6.667-3.851,14.953-3.852,21.622,0l40.262,23.246c1.627,0.939,2.598,2.62,2.598,4.497c0,1.879-0.971,3.561-2.597,4.5 l-40.262,23.244C464.779,222.335,461.041,223.297,457.302,223.297z M447.422,218.798c6.097,3.518,13.668,3.518,19.761,0 l40.262-23.244c1.043-0.602,1.666-1.683,1.666-2.888c0-1.205-0.623-2.284-1.666-2.887l-40.262-23.246 c-6.097-3.518-13.668-3.518-19.763,0l-40.26,23.245c-1.044,0.602-1.667,1.682-1.667,2.887c0,1.205,0.623,2.284,1.667,2.888 L447.422,218.798z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M288.875,186.79l25.729,14.855c1.484,0.857,3.892,0.857,5.376,0c1.485-0.857,1.484-2.247,0-3.104 l-25.729-14.855c-1.484-0.857-3.892-0.857-5.376,0C287.391,184.543,287.391,185.933,288.875,186.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#E8975B"
    },
    d: "M277.611,190.189c-1.485,0.857-1.484,2.247,0,3.104l39.578,22.85 c1.484,0.857,3.892,0.857,5.376,0c1.484-0.857,1.484-2.247,0-3.104l-39.578-22.85C281.503,189.333,279.095,189.333,277.611,190.189 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M266.347,199.797l7.936,4.582c1.485,0.857,3.892,0.857,5.376,0c1.485-0.857,1.485-2.247,0-3.104 l-7.936-4.582c-1.484-0.857-3.891-0.857-5.376,0C264.862,197.55,264.862,198.94,266.347,199.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E82B88"
    },
    d: "M255.083,206.3l22.401,12.933c1.484,0.857,3.892,0.857,5.376,0c1.485-0.857,1.484-2.247,0-3.104 l-22.401-12.933c-1.484-0.857-3.892-0.857-5.376,0C253.598,204.053,253.598,205.443,255.083,206.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M311.861,222.971c1.485-0.857,1.484-2.247,0-3.104l-22.401-12.934c-1.484-0.857-3.891-0.857-5.376,0 c-1.484,0.857-1.484,2.247,0,3.104l22.401,12.934C307.969,223.828,310.377,223.828,311.861,222.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#E8975B"
    },
    d: "M329.398,229.992l-1.316-0.76l-6.364-3.674c-1.484-0.857-3.891-0.857-5.376,0 c-1.484,0.857-1.484,2.247,0,3.104l6.364,3.674l1.316,0.76l6.364,3.674c1.485,0.857,3.892,0.857,5.376,0 c1.485-0.857,1.485-2.246,0-3.104L329.398,229.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M449.19,127.897c1.318-0.761,3.455-0.761,4.773,0l2.35,1.368c1.318,0.761,1.318,1.995,0,2.756 c-1.318,0.761-3.455,0.761-4.773,0l-2.35-1.368C447.871,129.892,447.871,128.658,449.19,127.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M426.873,126.834c1.318-0.761,3.455-0.761,4.773,0l14.439,8.336c1.318,0.761,1.318,1.995,0,2.756 c-1.319,0.761-3.455,0.761-4.773,0l-14.439-8.336C425.555,128.829,425.555,127.596,426.873,126.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M382.37,160.195c1.318-0.761,3.455-0.761,4.773,0l7.799,4.503c1.318,0.761,1.318,1.995,0,2.756 c-1.319,0.761-3.455,0.761-4.773,0l-7.799-4.503C381.052,162.19,381.052,160.956,382.37,160.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#E8975B"
    },
    d: "M393.573,154.852c1.318-0.761,3.456-0.761,4.773,0l6.825,3.94 c1.318,0.761,1.318,1.995,0,2.756c-1.319,0.761-3.455,0.761-4.773,0l-6.825-3.94C392.255,156.847,392.254,155.613,393.573,154.852 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#E8975B"
    },
    d: "M379.482,134.876c1.318-0.761,3.455-0.761,4.773,0l31.145,18.011 c1.318,0.761,1.318,1.995,0,2.756c-1.319,0.761-3.455,0.761-4.773,0l-31.145-18.011 C378.163,136.87,378.163,135.637,379.482,134.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M409.475,140.411c1.318-0.761,3.455-0.761,4.773,0l11.38,6.57c1.318,0.761,1.318,1.995,0,2.756 c-1.319,0.761-3.455,0.761-4.773,0l-11.38-6.57C408.157,142.406,408.157,141.173,409.475,140.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M424.258,137.136c1.318-0.761,3.456-0.761,4.773,0l6.825,3.94c1.318,0.761,1.318,1.995,0,2.756 c-1.319,0.761-3.455,0.761-4.773,0l-6.825-3.94C422.941,139.131,422.94,137.897,424.258,137.136z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M387.819,163.322c1.318-0.761,3.455-0.761,4.773,0l2.35,1.368c1.318,0.761,1.318,1.995,0,2.756 c-1.319,0.761-3.455,0.761-4.773,0l-2.35-1.368C386.5,165.317,386.5,164.083,387.819,163.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#E8975B"
    },
    d: "M348.796,152.585c1.318-0.761,3.455-0.761,4.773,0l31.145,18.011 c1.318,0.761,1.318,1.995,0,2.756c-1.319,0.761-3.455,0.761-4.773,0l-31.145-18.011 C347.478,154.579,347.478,153.346,348.796,152.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M346.181,162.886c1.318-0.761,3.455-0.761,4.773,0l23.531,13.615c1.318,0.761,1.318,1.995,0,2.756 c-1.319,0.761-3.455,0.761-4.773,0l-23.531-13.615C344.864,164.881,344.863,163.647,346.181,162.886z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143594808422515356720000007654441504803945879_",
    cx: 205.9983,
    cy: 216.712,
    r: 192.1395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4C02F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0082,
    style: {
      stopColor: "#4B02EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    style: {
      stopColor: "#3903C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2487,
    style: {
      stopColor: "#29039E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#1D0380"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    style: {
      stopColor: "#130468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6513,
    style: {
      stopColor: "#0C0457"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8062,
    style: {
      stopColor: "#07044D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#06044A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143594808422515356720000007654441504803945879_)"
    },
    d: "M390.716,209.013 c-0.439-1.134-0.962-2.258-1.529-3.377c-0.419,3.888-2.007,7.775-3.869,11.662c0.305,2.535,0.281,5.081-0.09,7.614l-4.488,1.603 l-12.311,12.073l-16.415,8.445l-18.913,6.602l-22.124,3.925h-18.912l-22.302-4.104l-25.692-6.423l-20.518-14.274l-8.005-7.102 c-0.27-1.556-0.388-3.118-0.402-4.68c-2.02-4.133-3.328-8.655-4.646-13.314c-0.25,0.579-0.485,1.159-0.703,1.741l-2.115-3.658 v16.01l0.039-0.036c0.421,13.358,9.442,26.642,27.099,36.837c36.183,20.89,94.846,20.891,131.027,0.001 c18.172-10.492,27.198-24.256,27.112-38.006l0.013,0.014v-14.821L390.716,209.013z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000010304431251101189660000015910261517878676403_",
    cx: 365.0965,
    cy: 231.5516,
    r: 185.7316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#4C02F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0082,
    style: {
      stopColor: "#4B02EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1263,
    style: {
      stopColor: "#3903C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2487,
    style: {
      stopColor: "#29039E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    style: {
      stopColor: "#1D0380"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    style: {
      stopColor: "#130468"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6513,
    style: {
      stopColor: "#0C0457"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8062,
    style: {
      stopColor: "#07044D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#06044A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010304431251101189660000015910261517878676403_)"
    },
    d: "M240.073,185.944 c33.28-19.214,87.237-19.214,120.517,0.001c15.125,8.732,23.355,19.931,24.728,31.353c1.862-3.887,3.449-7.775,3.869-11.662 c-0.926-1.829-2.001-3.637-3.275-5.411l2.679-0.235l-13.203-23.075L336.73,158.36l-34.851-4.282l-29.796,3.747l-18.912,3.568 l-15.344,7.137l-15.879,11.597l-7.85,15.523l-0.989,7.035c-1.015,1.639-1.881,3.301-2.607,4.98 c1.317,4.659,2.626,9.181,4.646,13.314C215.035,208.305,223.325,195.614,240.073,185.944z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000130642713956955986390000013220822136880920471_",
    cx: 233.9155,
    cy: 139.9892,
    r: 201.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#A92FFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5875,
    style: {
      stopColor: "#891CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      stopColor: "#6507FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3919BB"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000130642713956955986390000013220822136880920471_)"
    },
    cx: 300.333,
    cy: 211.525,
    rx: 85.219,
    ry: 49.201
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000052069904723256799150000005440985222917882015_",
    cx: 228.1235,
    cy: 127.9732,
    r: 218.7622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#A92FFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5875,
    style: {
      stopColor: "#891CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      stopColor: "#6507FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3919BB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052069904723256799150000005440985222917882015_)"
    },
    d: "M365.845,167.924 c-36.183-20.89-94.846-20.89-131.027-0.001c-36.182,20.89-36.181,54.759,0.002,75.649s94.846,20.891,131.027,0.001 C402.029,222.683,402.028,188.814,365.845,167.924z M360.592,240.539c-33.279,19.214-87.237,19.213-120.517-0.001 c-33.28-19.215-33.281-50.367-0.002-69.581c33.28-19.214,87.237-19.214,120.517,0.001S393.872,221.325,360.592,240.539z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000024722803515479861040000002047508986745356691_",
    cx: 234.1923,
    cy: 145.0951,
    r: 193.8476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#A92FFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5875,
    style: {
      stopColor: "#891CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      stopColor: "#6507FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3919BB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000024722803515479861040000002047508986745356691_)"
    },
    d: "M240.073,179.827 c-14.684,8.478-22.878,19.28-24.604,30.355c1.726,11.076,9.921,21.878,24.606,30.356c33.28,19.214,87.238,19.215,120.517,0.001 c14.684-8.477,22.878-19.279,24.604-30.354c-1.726-11.076-9.921-21.878-24.606-30.356 C327.31,160.613,273.353,160.613,240.073,179.827z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000045587972926993744160000003170707357801922998_",
    cx: 484.9169,
    cy: 325.6252,
    r: 178.8139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E39A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#A92FFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5875,
    style: {
      stopColor: "#891CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      stopColor: "#6507FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3919BB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045587972926993744160000003170707357801922998_)"
    },
    d: "M477.642,327.354 c-0.969,0-1.95-0.247-2.849-0.767l-115.517-66.694c-2.731-1.577-3.667-5.068-2.089-7.799c1.576-2.732,5.067-3.669,7.799-2.089 l115.517,66.694c2.731,1.576,3.667,5.068,2.089,7.799C481.535,326.329,479.615,327.354,477.642,327.354z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#020230"
    },
    d: "M364.986,250.005c-2.732-1.579-6.223-0.643-7.799,2.089 c-1.577,2.731-0.641,6.222,2.089,7.799l8.326,4.807l0,0c0,0-3.028-7.66,5.947-9.751l0,0L364.986,250.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M193.14,243.289c1.313-0.758,3.442-0.758,4.756,0l31.033,17.947c1.313,0.758,1.313,1.988,0,2.746 c-1.314,0.758-3.443,0.758-4.756,0l-31.033-17.947C191.826,245.276,191.826,244.047,193.14,243.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M148.796,276.53c1.313-0.758,3.442-0.759,4.756,0l24.417,14.127c1.313,0.758,1.313,1.988,0,2.746 c-1.314,0.759-3.443,0.758-4.756,0l-24.417-14.127C147.482,278.518,147.482,277.289,148.796,276.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#E8975B"
    },
    d: "M176.605,280.847c1.313-0.758,3.443-0.758,4.756,0l6.8,3.926 c1.313,0.758,1.313,1.988,0,2.746c-1.314,0.759-3.443,0.758-4.756,0l-6.8-3.926 C175.292,282.835,175.291,281.605,176.605,280.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M179.21,270.582c1.313-0.758,3.442-0.759,4.756,0l14.387,8.306c1.313,0.758,1.313,1.988,0,2.746 c-1.314,0.759-3.443,0.758-4.756,0l-14.387-8.306C177.896,272.57,177.896,271.341,179.21,270.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M192.45,266.458c1.313-0.758,3.443-0.758,4.756,0l11.339,6.547c1.313,0.758,1.313,1.988,0,2.746 c-1.314,0.758-3.443,0.758-4.756,0l-11.339-6.547C191.137,268.446,191.137,267.216,192.45,266.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#E82B88"
    },
    d: "M190.535,253.553c1.313-0.758,3.443-0.758,4.756,0l23.447,13.567 c1.313,0.758,1.313,1.988,0,2.746c-1.314,0.759-3.443,0.758-4.756,0l-23.447-13.566 C189.221,255.541,189.221,254.312,190.535,253.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M154.225,279.646c1.313-0.758,20.089,8.882,21.402,9.64l2.342,1.363 c1.313,0.758,1.313,1.988,0,2.746c-1.314,0.758-3.443,0.758-4.756,0l-2.342-1.363 C169.558,291.274,152.912,280.405,154.225,279.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M148.634,288.228c1.313-0.758,3.443-0.759,4.756,0l14.387,8.306c1.313,0.758,1.313,1.988,0,2.746 c-1.314,0.759-3.443,0.758-4.756,0l-14.387-8.306C147.321,290.215,147.321,288.986,148.634,288.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M146.029,298.492c1.313-0.758,3.443-0.758,4.756,0l6.8,3.926c1.313,0.758,1.313,1.988,0,2.746 c-1.314,0.759-3.443,0.758-4.756,0l-6.8-3.926C144.716,300.48,144.715,299.251,146.029,298.492z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M457.046,179.044l20.883,12.057c1.205,0.695,3.159,0.696,4.364,0c1.205-0.696,1.205-1.824,0-2.519 l-20.883-12.057c-1.205-0.696-3.159-0.696-4.364,0C455.841,177.221,455.841,178.349,457.046,179.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#E8975B"
    },
    d: "M447.903,181.804c-1.205,0.696-1.205,1.824,0,2.519l17.829,10.341 c1.205,0.695,3.159,0.696,4.364,0c1.205-0.696,1.205-1.824,0-2.519l-17.829-10.341 C451.062,181.108,449.108,181.108,447.903,181.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M438.76,189.602l6.441,3.719c1.205,0.696,3.159,0.695,4.364,0c1.205-0.696,1.205-1.823,0-2.519 l-6.441-3.719c-1.205-0.696-3.158-0.696-4.364,0C437.555,187.778,437.555,188.906,438.76,189.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E82B88"
    },
    d: "M429.617,194.88l18.182,10.497c1.205,0.696,3.159,0.696,4.364,0c1.205-0.696,1.205-1.824,0-2.519 l-18.182-10.498c-1.205-0.696-3.159-0.696-4.364,0C428.412,193.057,428.413,194.184,429.617,194.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M469.325,204.704c1.205-0.696,1.205-1.824,0-2.519l-11.805-6.79c-1.205-0.696-3.158-0.696-4.364,0 c-1.205,0.695-1.205,1.824,0,2.519l11.805,6.79C466.166,205.399,468.12,205.399,469.325,204.704z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8975B"
    },
    d: "M106.879,233.381l20.883,12.057c1.205,0.695,3.159,0.696,4.364,0c1.205-0.696,1.205-1.824,0-2.519 l-20.883-12.057c-1.205-0.696-3.159-0.696-4.364,0C105.674,231.558,105.674,232.686,106.879,233.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#E8975B"
    },
    d: "M97.736,236.141c-1.205,0.696-1.205,1.824,0,2.519l17.829,10.341 c1.205,0.696,3.159,0.696,4.364,0c1.205-0.696,1.205-1.824,0-2.519L102.1,236.141C100.895,235.445,98.941,235.445,97.736,236.141z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about1.6a048402dcd08031dd9da1e137b1e9fb.svg";
export { ForwardRef as ReactComponent };